
import RcDomainObject from "@/domain/common/RcDomainObject";

import ChecklistItemResult from "./ChecklistItemResult.js";
import ChecklistItemResultMap from "./ChecklistItemResultMap.js";

export default class CheckListItemResultsDomain extends RcDomainObject {
  
  constructor(domain, storage) {
    super(domain);
    this._storage = storage.ChecklistItemResultStorage;
  }

  list() {
    return this._storage.list;
  }
  
  
  findById(objId) {
    var object = this._storage.map[objId];
    return new ChecklistItemResult(this.domain, object);
  }
  
  findByAll() {
    var objects = this.list();
    var map = new ChecklistItemResultMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var result = new ChecklistItemResult(this.domain, item);
      map.add(result);
    }

    return map;
  }

}